<template>
  <div>
    <Loader :loader-primario="loader" />

    <Alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
    />

    <v-container>
      <v-row>
        <v-col cols="12">
          <h2 class="categoria titulo-secao">Detalhes PDI</h2>
        </v-col>
      </v-row>
    </v-container>

    <ViewInicialPdi
      v-show="!isForm"
      :listaPdi="listaPdi"
      :isHistorico="true"
      @toggle-form="toggleForm"
    />

    <ViewFormPdi
      v-show="isForm"
      :idPdi="idPdi"
      :dadosColaborador="dadosColaborador"
      :disabled="true"
      @toggle-form="toggleForm"
      @error="message => mensagemErro(message)"
    />
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Alerta from '@/components/Alerta.vue';
import ViewInicialPdi from '../Pdi/ViewInicialPdi.vue';
import ViewFormPdi from '../Pdi/ViewFormPdi.vue';
import modalMixin from '@/mixins/modalMixin';
import api from '@/services/Api.js';
import JS from '../methods.js';

export default {
  name: 'ViewPdi',
  components: { Loader, Alerta, ViewInicialPdi, ViewFormPdi, api },
  mixins: [modalMixin],
  props: {
    cod_avaliacao: { type: Number, default: null },
  },
  data() {
    return {
      loader: false,
      isForm: false,
      idPdi: null,
      listaPdi: [],

      ciclo: {},
      dadosColaborador: {},
    };
  },
  methods: {
    ...JS,
    toggleForm(id = null) {
      this.idPdi = id;
      this.isForm = !this.isForm;
    },
    async fetchPdiList() {
      if (!this.cod_avaliacao) return;

      try {
        const { data } = await api.get(`pdi/avaliacao/${this.cod_avaliacao}`);
        this.listaPdi = data;
      } catch (e) {
        this.mensagemErro(e.message);
      }
    },
    async fetchCiclos() {
      this.loader = true;
      try {
        const { status, data } = await api.get(`avaliacaoDesempenho/ciclosColaborador`, {
          headers: { Authorization: localStorage.token },
          withCredentials: true,
          params: { page: 1, perPage: 10 },
        });
        if (status !== 200) return;
        this.ciclo = await data.result.find(c => c.status === 'Iniciado');
        this.fetchDadosColaborador();
      } catch (e) {
        this.mensagemErro(e.message);
      } finally {
        this.loader = false;
      }
    },
    async fetchDadosColaborador() {
      try {
        const { data } = await api.get(`AutoAvaliados/getDadosByCodCicloColaborador/`, {
          params: { cod_ciclo_colaborador: this.ciclo.codAutoAvaliacao },
        });
        this.dadosColaborador = data;
      } catch (e) {
        this.mensagemErro(e.message);
      }
    },
  },
  async mounted() {
    this.fetchPdiList();
    this.fetchCiclos();
  },
};
</script>

<style scoped>
.categoria {
  position: relative;
  padding-left: 1rem;
  text-transform: none;
}
.categoria::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0.25rem;
  height: 90%;
  background-color: #278b97;
  border-radius: 0.25rem 0 0 0.25rem;
}
</style>
